// extracted by css-extract-rspack-plugin
export default {"cls1":"ScrollableTabNav-wjs-cls1_l7h","cls2":"ScrollableTabNav-wjs-cls2_jcH ScrollableTabNav-wjs-cls1_l7h","hidden":"ScrollableTabNav-wjs-hidden_G_k"};